import {
  Button,
  Form,
  Input,
  Label,
  Modal,
  ModalBody,
  Row,
  Col,
  Spinner,
  Container,
} from "reactstrap";
import logo from "../assets/imgs/new/paymentSuccess.png";
import MemoraLogo from "../assets/imgs/memora_logo_small.png";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  getSingleMedia,
  getSingleMemoir,
} from "../redux/actions/memoir.action";
import moment from "moment";
import "react-multi-carousel/lib/styles.css";
import { Link, useLocation, useParams } from "react-router-dom";
import { createCollabRequest } from "../redux/actions/collaboratives.action";

import AlertLogo from "../assets/imgs/new/paymentSuccess.png";
import MemoirMedia from "../components/MemoirMedia";

const Timeline_main = (props) => {
  // const location = useLocation();
  // const  state  = location.state;
  // console.log(state,'dataaa')
  console.log(props, "props");
  const [loginModal, setLoginModal] = useState(false);
  const [collabModal, setCollabModal] = useState(false);
  const [role, setRole] = useState("contributor");
  const dispatch = useDispatch();
  const { singleMemoir } = useSelector((state) => state.memoir);
  const { loading } = useSelector((state) => state.collaborative);
  const authUser = useSelector((state) => state.authUser);
  const [alertModal, setAlertModal] = useState(false);
  const [copiedAlert, setCopiedAlert] = useState(false);
  const { id } = useParams();
  console.log("singleMemoir", singleMemoir);

  const copyTextToClipboard = () => {
    navigator.clipboard.writeText(
      `https://memora-main.web.app/main/timeline/${id}`
    );
    setCopiedAlert(true);
    setTimeout(() => {
      setCopiedAlert(false);
    }, 1000);
  };

  useEffect(() => {
    dispatch(getSingleMemoir(props.match.params.id));
    dispatch(getSingleMedia(props.match.params.id));
  }, []);

  const collabToggle = () => {
    setCollabModal(!collabModal);
  };

  useEffect(() => {
    if (singleMemoir && singleMemoir.isMemoirPublic == false) {
      if (authUser?.id) {
        if (singleMemoir?.user_id != authUser?.id) {
          setAlertModal(true);
        }
      } else {
        setAlertModal(true);
      }
    }
  }, [singleMemoir]);

  return (
    <>
      <Modal
        // isOpen={alertModal}
        centered
        className="time_line_main_alert"
      >
        <ModalBody className="text-center bg-white">
          <img src={AlertLogo} alt="Alert Logo" />
          <br />

          {authUser && authUser.id ? (
            <>
              <Row className="justify-content-center mt-2">
                <Col md="12">
                  <span className="main_text">This Memoir is Private</span>
                  <br />
                  <span className="sub_text mt-2">
                    Go to dashboard to view this memoir!
                  </span>
                </Col>
              </Row>
              <Row className="mt-3 justify-content-center">
                <Col md="5">
                  <Link to="/dashboard/manage-account">
                    <Button className=" btn-outline landing-btn">
                      DASHBOARD
                    </Button>
                  </Link>
                </Col>
              </Row>
            </>
          ) : (
            <>
              <Row className="justify-content-center mt-2">
                <Col md="12">
                  <span className="main_text">
                    You need to be
                    <br /> logged in to do this
                  </span>
                  <br />
                  <span className="sub_text mt-2">
                    please sign up or log in below
                  </span>
                </Col>
              </Row>

              <Row className="mt-3 justify-content-center">
                <Col md="5">
                  <Link to="/dashboard/register">
                    <Button className="btn-outline landing-btn" width="100%">
                      Login
                    </Button>
                  </Link>
                </Col>
                <Col md="5">
                  <Link to="/dashboard/register">
                    <Button className=" btn-outline landing-btn">
                      SIGN UP
                    </Button>
                  </Link>
                </Col>
              </Row>
            </>
          )}
        </ModalBody>
      </Modal>

      {singleMemoir ? (
        <>
          <div
            className="memoir"
            style={{
              background: `linear-gradient(180deg, rgba(219, 195, 166,0) 0%, #DBC3A6 65.94%),url(${
                singleMemoir.cover_image ? singleMemoir.cover_image : MemoraLogo
              })`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              width: "100%",
              backgroundSize: "cover",
            }}
          >
            <div
              className="avatar-update-container profile"
              style={{
                background: "transparent",
              }}
            >
              <label for="file" className="avatar-update">
                {singleMemoir.display_image && (
                  <img
                    src={singleMemoir.display_image}
                    className="rounded-circle"
                  />
                )}
              </label>
            </div>
            <div className="text-center pt-4">
              <h3 className="font-weight-bold">
                {singleMemoir.memoir_title}
                {/* Alessandro del Lamborghini */}
              </h3>
              <div className="d-flex align-items-center mt-2 justify-content-center">
                <h5 className="m-0 font-weight-bold">
                  {singleMemoir.else_category
                    ? moment(singleMemoir.start_date).format("DD MMMM YYYY")
                    : moment(singleMemoir.date_of_birth).format("DD MMMM YYYY")}
                  {/* 7 May 1969 */}
                </h5>
                <div className="mx-4 v-line"></div>
                <h5 className="m-0 font-weight-bold">
                  {singleMemoir.else_category
                    ? moment(singleMemoir.end_date).format("DD MMMM YYYY")
                    : singleMemoir.date_of_death
                    ? moment(singleMemoir.date_of_death).format("DD MMMM YYYY")
                    : "Current"}
                  {/* 10 September 2018 */}
                </h5>
              </div>
              {singleMemoir && singleMemoir.isIntroductionVisible && (
                <p className="container mt-2">{singleMemoir.introduction}</p>
              )}
            </div>
            <div className="mt-2 pb-4 d-flex flex-wrap justify-content-center">
              {singleMemoir.isMemoirPublic ? (
                <Button
                  className="btn-outline mr-3 landing-btn"
                  onClick={copyTextToClipboard}
                >
                  <span className="mr-2">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 19 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.8333 14.8434C15.0311 14.8434 14.3133 15.1596 13.7644 15.6551L6.23833 11.2801C6.29111 11.0377 6.33333 10.7952 6.33333 10.5422C6.33333 10.2892 6.29111 10.0467 6.23833 9.80422L13.68 5.47139C14.25 5.99849 14.9994 6.3253 15.8333 6.3253C17.5856 6.3253 19 4.91265 19 3.16265C19 1.41265 17.5856 0 15.8333 0C14.0811 0 12.6667 1.41265 12.6667 3.16265C12.6667 3.41566 12.7089 3.65813 12.7617 3.9006L5.32 8.23343C4.75 7.70633 4.00056 7.37952 3.16667 7.37952C1.41444 7.37952 0 8.79217 0 10.5422C0 12.2922 1.41444 13.7048 3.16667 13.7048C4.00056 13.7048 4.75 13.378 5.32 12.8509L12.8356 17.2364C12.7828 17.4578 12.7511 17.6898 12.7511 17.9217C12.7511 19.619 14.1339 21 15.8333 21C17.5328 21 18.9156 19.619 18.9156 17.9217C18.9156 16.2244 17.5328 14.8434 15.8333 14.8434Z"
                        fill="black"
                      />
                    </svg>
                  </span>
                  {copiedAlert ? "URL copied" : " Share"}
                </Button>
              ) : (
                ""
              )}

              <Button
                className="btn-outline mr-3 landing-btn "
                onClick={collabToggle}
              >
                <span className="mr-2">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 35 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M25.9091 10.2857C28.7764 10.2857 31.0736 7.98857 31.0736 5.14286C31.0736 2.29714 28.7764 0 25.9091 0C23.0418 0 20.7273 2.29714 20.7273 5.14286C20.7273 7.98857 23.0418 10.2857 25.9091 10.2857ZM12.0909 10.2857C14.9582 10.2857 17.2555 7.98857 17.2555 5.14286C17.2555 2.29714 14.9582 0 12.0909 0C9.22364 0 6.90909 2.29714 6.90909 5.14286C6.90909 7.98857 9.22364 10.2857 12.0909 10.2857ZM12.0909 13.7143C8.06636 13.7143 0 15.72 0 19.7143V24H24.1818V19.7143C24.1818 15.72 16.1155 13.7143 12.0909 13.7143ZM25.9091 13.7143C25.4082 13.7143 24.8382 13.7486 24.2336 13.8C26.2373 15.24 27.6364 17.1771 27.6364 19.7143V24H38V19.7143C38 15.72 29.9336 13.7143 25.9091 13.7143Z"
                      fill="black"
                    />
                  </svg>
                </span>
                Request for Collaboration
              </Button>
            </div>
            {/* {singleMemoir.isMemoirPublic?(''):(<h5 className="text-center text-danger">This memoir is private</h5>)} */}
          </div>
          {singleMemoir.isMemoirPublic ? (
          <MemoirMedia memoir_id={props.match.params.id} isEditable={false} />):(
            <div className="my-5 d-flex flex-column align-items-center justify-content-center">
            <i class="fas fa-lock" style={{ fontSize: "2em" }}></i>
            <h6 className="main_text my-1 text-danger">
              This Memoir is Private
            </h6>
            <span className="sub_text mt-2">
              Go to dashboard to view this memoir!
            </span>
          </div>
          )}
        </>
      ) : (
        ''
      )}
      <Modal
        // className='bg-white'
        isOpen={loginModal}
        toggle={(e) => setLoginModal(!loginModal)}
      >
        <ModalBody className="text-center">
          <div className="d-flex align-items-center justify-content-center py-4">
            <img className="mx-auto" src={logo} />
          </div>
          <h5>You need to be logged in to do this</h5>
          <p>
            Only Memories users can perform this action, please sign up or log
            in below
          </p>
          <div className="d-flex align-items-center" style={{ gap: 10 }}>
            <Button className="m-0 btn-outline w-100 h-auto landing-btn" block>
              Log in
            </Button>
            <Button className="m-0 btn-outline w-100 h-auto landing-btn" block>
              Sign up
            </Button>
          </div>
        </ModalBody>
      </Modal>
      <Modal
        centered
        isOpen={collabModal}
        toggle={collabToggle}
        // className='bg-white'
      >
        <ModalBody className="bg-white rounded">
          {authUser ? (
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                let obj = {
                  requestor_id: authUser.id,
                  memoir_id: props.match.params.id,
                  memoir_creator: singleMemoir.user_id,
                  role: role,
                };
                dispatch(createCollabRequest(obj)).then((res) => {
                  collabToggle();
                });
              }}
            >
              {authUser && authUser.id == singleMemoir.user_id ? (
                <Label>Oops! you are the creator of this memoir</Label>
              ) : (
                <>
                  <Label>Select Role</Label>
                  <Input
                    type="select"
                    value={role}
                    onChange={(e) => setRole(e.target.value)}
                  >
                    <option value="contributor" selected>
                      Contributor
                    </option>
                    <option value="admin">Admin</option>
                  </Input>
                  <div className="text-right mt-3">
                    <Button
                      type="submit"
                      className="btn-outline landing-btn"
                      disabled={loading}
                    >
                      {loading ? <Spinner size="md" /> : "Submit"}
                    </Button>
                  </div>
                </>
              )}
            </Form>
          ) : (
            <div className="text-center">
              Login to send Request
              <br />
              <Link to="/dashboard/register">
                <Button className="btn-outline mt-3 landing-btn">Log in</Button>
              </Link>
            </div>
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default Timeline_main;
